import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const BLOCKS = [
  {
    n: "01", t: "The nine questions",
    b: "Market, age range, goal, diet pattern, weekly food frequency, activity, sleep, routine factors, and one safety flag. No medical free text, no medicine names, no lab values. Sensitive answers always offer 'prefer not to say' — and the plan turns conservative when you use it.",
  },
  {
    n: "02", t: "The rules engine",
    b: "Deterministic and versioned — no AI improvisation. Precedence is fixed: consent and market, then hard safety gates, then evidence eligibility, then food-pattern gaps, then goal relevance, then feasibility. The same answers always produce the same plan.",
  },
  {
    n: "03", t: "The evidence grades",
    b: "A — current public-health guidance or high-quality guidelines (shapes plans). B — consistent systematic reviews or robust trials (shapes plans, cautiously). C — limited or mixed evidence (education only). D — early signals (research-watch only). X — regulatory warnings or rejected claims (suppressed everywhere).",
  },
  {
    n: "04", t: "The supplement ceiling",
    b: "A plan never contains more than two supplement categories, and only after food-first actions. When evidence is mixed or your pattern does not need one, the plan says 'skip' — a plan that adds nothing is a feature, not a gap.",
  },
  {
    n: "05", t: "The commercial firewall",
    b: "There are no affiliate links, sponsored placements, or commission-weighted rankings on this platform. If commerce ever arrives, ranking criteria will be published in full and commission will carry 0% weight.",
  },
  {
    n: "06", t: "Your data",
    b: "No accounts, no email, no names. Your plan lives at an anonymous link for 30 days, then is deleted. Nothing health-related is sent to advertisers — there are none.",
  },
];

export default function Method() {
  return (
    <main className="min-h-screen pt-28 pb-24 px-4 sm:px-6" data-testid="method-page">
      <div className="mx-auto max-w-3xl">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-clay mb-4">the method</p>
          <h1 className="font-serif text-4xl sm:text-6xl font-extrabold uppercase tracking-tight leading-[0.95]" data-testid="method-title">
            How Zinda Banda decides. <span className="italic text-sage">Published, not promised.</span>
          </h1>
          <p className="mt-5 text-slatem leading-relaxed max-w-2xl">
            Trust is a mechanism, not a tagline. Here is the whole machine — questions, rules, grades, limits and data handling.
          </p>
        </Reveal>

        <div className="mt-14 space-y-5">
          {BLOCKS.map((x, i) => (
            <Reveal key={x.n} delay={i * 0.04}>
              <div className="rounded-3xl border border-ink/12 bg-bone p-7 sm:p-8" data-testid={`method-block-${x.n}`}>
                <div className="flex items-baseline gap-4 mb-3">
                  <span className="font-serif text-3xl font-bold text-clay/50">{x.n}</span>
                  <h2 className="font-serif text-xl sm:text-2xl font-bold uppercase tracking-tight">{x.t}</h2>
                </div>
                <p className="text-sm sm:text-base text-ink/75 leading-relaxed">{x.b}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-14 text-center">
            <Link to="/check-in" data-testid="method-cta"
              className="group inline-flex items-center gap-2.5 rounded-full bg-ink text-bone px-8 py-4 text-base font-semibold transition-colors duration-200 hover:bg-clay min-h-[44px]">
              Take the test <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5" />
            </Link>
          </div>
        </Reveal>
      </div>
    </main>
  );
}
